<template>
    <div id="reservation">
        <a-spin
            :spinning="loading"
            style="width: 100%; display: flex"
            v-if="!$route.params.id || (!!$route.params.id && Object.keys(reservationPlan).length > 0)"
        >
            <div class="left">
                <div class="content">
                    <div class="title">{{ $t("calendar.appointProgram") }}</div>
                    <SupsisButton v-if="!!this.$route.params.id" class="go-link" @click="goLink()">
                        <span class="material-icons icon">open_in_new</span>
                        {{ $t('message.goToLink') }}
                    </SupsisButton>
                    <div class="input-area">
                        <input class="label-input" v-model="title" :placeholder="$t('message.newTitleContent')" />
                    </div>
                    <div v-if="pageNumber === 1">
                        <Duration v-model="duration" />
                        <Availability v-model="availability" />
                        <Plan v-model="plan" />
                        <Setting v-model="setting" />
                        <Calendar v-model="calendarData" />
                    </div>
                    <div v-else>
                        <Description v-model="description" />
                        <Form v-model="formInputs" />
                    </div>
                </div>
                <div class="footer">
                    <SupsisButton class="btn back" @click="backPage()">{{ $t("wp.wpBack") }}</SupsisButton>
                    <SupsisButton class="btn preview" @click="preview()">
                        <span class="material-icons preview-icon">visibility</span>
                        {{ $t("chatbotv2.preview") }}
                    </SupsisButton>
                    <SupsisButton class="btn" @click="nextPage()"
                        >{{ pageNumber === 1 ? $t("message.forward") : $t("message.save") }}
                    </SupsisButton>
                </div>
            </div>
            <div class="right">
                <FullCalendar :options="calendarOptions" ref="calendar" />
            </div>
        </a-spin>
    </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
import { log2 } from "../../../../utils/log2";
import moment from "moment/moment";
import Duration from "./Reservation/Duration.vue";
import Availability from "./Reservation/Availability.vue";
import FullCalendar from "@fullcalendar/vue";
import timeGridPlugin from "@fullcalendar/timegrid";
import momentTz from "moment-timezone";
import Plan from "./Reservation/Plan.vue";
import Setting from "./Reservation/Setting.vue";
import Calendar from "./Reservation/Calendar.vue";
import Description from "./Reservation/Description.vue";
import Form from "./Reservation/Form.vue";
import SupsisButton from "../../../../components/common/SupsisButtonOld.vue";
import { CALENDAR_API } from "../../../../api/calendar";
import _ from "lodash";
import CONFIG from "../../../../config/config";

const log = log2("Reservation");
export default {
    name: "Reservation",
    components: {
        Duration,
        Availability,
        FullCalendar,
        Plan,
        Setting,
        Calendar,
        Description,
        Form,
        SupsisButton,
    },
    props: {},
    data() {
        return {
            title: "",
            duration: 60,
            availability: {
                timezone: momentTz.tz.guess(),
                rules: [],
            },
            plan: {
                isAvailableNow: true,
                customProgramDates: {
                    startDate: moment().utc().format().split("T")[0],
                    endDate: moment().add(10, "years").utc().format().split("T")[0],
                },
                isMaxBookingDay: false,
                maxBookingDay: 30,
                isMinBookingHour: false,
                minBookingHour: 1,
            },
            setting: {
                isBufferTimeMinute: false,
                bufferTimeMinute: 10,
                isMaxBookingCountPerDay: false,
                maxBookingCountPerDay: 5,
            },
            calendarOptions: {
                selectable: true,
                plugins: [timeGridPlugin],
                initialView: "timeGridWeek",
                headerToolbar: {
                    start: "today prev,next",
                    center: "title",
                    end: "",
                },
                datesSet: this.dataSet,
                initialDate: moment().utc().format().split("T")[0],
                events: [],
            },
            formInputs: [
                {
                    type: "custom",
                    label: "name",
                    required: true,
                    isDefault: true,
                },
                {
                    type: "custom",
                    label: "surname",
                    required: true,
                    isDefault: true,
                },
                {
                    type: "email",
                    label: "email",
                    required: true,
                    isDefault: true,
                },
            ],
            calendarData: {
                availabilityCalendarIds: [],
                calendarId: "",
            },
            description: "",
            pageNumber: 1,
            reservationPlan: {},
            busyTimes: [],
            calendarList: [],
            isDataMounted: false,
            loading: true,
            isCompleted: false,
            end: moment().endOf("week").utc().format(),
        };
    },
    computed: {
        ...mapState({
            user: (state) => state.auth.user,
            site: (state) => state.site.site,
        }),
    },
    methods: {
        ...mapActions({
            getCalendarEvents: "calendar/getCalendarEvents",
            getCalendarList: "calendar/getCalendarList",
        }),
        dataSet(val) {
            this.end = moment(val.end).utc().format();
        },
        goLink() {
            const reservationId = this.$route.params.id || this.reservationPlan._id;
            const reservationURL = `${CONFIG.CALENDAR_URL}/?reservationId=${reservationId}&siteId=${this.site._id}&userId=${this.user._id}`;
            window.open(reservationURL, "_blank");
        },
        createLink() {
            const reservationURL = `${CONFIG.CALENDAR_URL}/?reservationId=${this.reservationPlan._id}&siteId=${this.site._id}&userId=${this.user._id}`;
            this.isCompleted = true;
            this.$router.replace("/calendar");
            this.$message.success(this.$t("calendar.resPlanCreateSuccess"));
        },
        async nextPage() {
            if (this.title === "") return this.$message.error(this.$t("calendar.pleaseEnterTitle"));
            if (this.pageNumber === 2) {
                await this.saveReservation();
                this.createLink();
            } else {
                this.pageNumber = 2;
            }
        },
        async preview() {
            await this.saveReservation();
            this.goLink();
        },
        async saveReservation() {
            const reservationPlanId = this.$route.params.id || this.reservationPlan._id;
            const data = {
                userId: this.user._id,
                title: this.title,
                duration: this.duration,
                availability: this.availability,
                isAvailableNow: this.plan.isAvailableNow,
                customProgramDates: {
                    startDate: this.plan.customProgramDates.startDate,
                    endDate: this.plan.customProgramDates.endDate,
                },
                booking: {
                    isMaxBookingDay: this.plan.isMaxBookingDay,
                    maxBookingDay: this.plan.maxBookingDay,
                    isMinBookingHour: this.plan.isMinBookingHour,
                    minBookingHour: this.plan.minBookingHour,
                },
                setting: {
                    isBufferTimeMinute: this.setting.isBufferTimeMinute,
                    isMaxBookingCountPerDay: this.setting.isMaxBookingCountPerDay,
                    bufferTimeMinute: this.setting.bufferTimeMinute,
                    maxBookingCountPerDay: this.setting.maxBookingCountPerDay,
                },
                availabilityCalendarIds: this.calendarData.availabilityCalendarIds,
                calendarId: this.calendarData.calendarId,
                description: this.description,
                formInputs: this.formInputs,
            };
            if (!this.$route.params.id && !this.reservationPlan._id)
                await CALENDAR_API.createReservationPlan(data).then((res) => {
                    this.reservationPlan = res;
                });
            else await CALENDAR_API.updateReservationPlan({ reservationPlanId, data });
        },
        async backPage() {
            if (this.pageNumber === 1) {
                if (!this.$route.params.id && this.reservationPlan._id) {
                    await CALENDAR_API.deleteReservationPlan(this.reservationPlan._id);
                }
                this.$router.push("/calendar");
            } else this.pageNumber = 1;
        },
        getDate(hours, minutes, day, index) {
            // ilgli gün için başlangı ve bitiş tarihlerini getiri
            let getDate = new Date();
            getDate.setHours(_.toInteger(hours));
            getDate.setMinutes(_.toInteger(minutes));
            let value = moment(getDate).utc();
            const currentDay = getDate.getDay(); // 2 - 1
            let diff = day - currentDay;
            if (diff < 0) diff = 7 - diff * -1;
            if (currentDay === 0) diff = day;
            value.add(diff + index * 7, "days");
            return value.format();
        },
        separateEvents(start, end) {
            // belirlenen başlangıç ve bitiş tarhihlerini molalara ve randevu süresine göre ayırır
            let events = [];
            let startValue = moment(start).utc();
            let endValue = moment(end).utc();
            while (startValue < endValue) {
                let event = {};
                event.start = startValue.format();
                startValue.add(this.duration, "minutes");
                event.end = startValue.format();
                if (event.end > endValue.format()) break;
                if (this.busyTimes.length > 0) {
                    const isBusy = this.busyTimes.find((busy) => {
                        return (
                            (moment(busy.start).utc().isSameOrBefore(event.start) &&
                                moment(busy.end).utc().isSameOrAfter(event.end)) ||
                            moment(event.start).utc().isBetween(busy.start, busy.end) ||
                            moment(event.end).utc().isBetween(busy.start, busy.end)
                        );
                    });
                    if (isBusy) {
                        console.log("isbusy..", { isBusy });
                        const color = this.calendarList.find((item) => item._id === isBusy.calendarId)?.color;
                        event.start = moment(isBusy.start).utc().format();
                        event.end = moment(isBusy.end).utc().format();
                        event.color = color;
                        event.title = isBusy.summary;
                        event._id = isBusy._id;
                        if (!events.map((x) => x._id).includes(isBusy._id)) events = [...events, event];
                    } else events = [...events, event];
                } else events = [...events, event];
                startValue.add(this.setting.bufferTimeMinute, "minutes");
            }
            return events;
        },
        calenderUpdated() {
            // seçilen duration end den daha fazla olabilir !! kontrol et
            let allEvents = [];
            if (this.availability.rules.length === 0 || !this.isDataMounted) {
                this.calendarOptions.events = [];
            } else {
                let start = this.plan.customProgramDates.startDate;
                let end = this.plan.customProgramDates.endDate;
                let index = 0;
                while (start < this.end) {
                    this.availability.rules.forEach((rule) => {
                        const days = _.isArray(rule.days) ? rule.days : rule.days.split("-");
                        days.forEach((day) => {
                            const start = this.getDate(rule.from.split(":")[0], rule.from.split(":")[1], day, index);
                            const end = this.getDate(rule.to.split(":")[0], rule.to.split(":")[1], day, index);
                            const events = this.separateEvents(start, end);
                            allEvents = [...allEvents, ...events];
                        });
                    });
                    start = moment(start).add(1, "week").format();
                    index += 1;
                }
            }
            this.calendarOptions.events = allEvents;
        },
        getBusyCalendarEvents() {
            const data = {
                calendarIds: this.calendarData.availabilityCalendarIds,
                userId: this.user._id,
                startDate: this.plan.isAvailableNow
                    ? moment().utc().format().split("T")[0]
                    : this.plan.customProgramDates.startDate,
                endDate: this.plan.isAvailableNow
                    ? moment().utc().add(1, "month").format().split("T")[0]
                    : this.plan.customProgramDates.endDate,
            };
            this.getCalendarEvents(data).then((res) => {
                this.busyTimes = res;
                this.calenderUpdated();
            });
        },
    },
    async mounted() {
        const { id } = this.$route.params;
        this.calendarList = await this.getCalendarList({ userId: this.user._id, userName: this.user.name });
        if (!!id) {
            await CALENDAR_API.getReservationPlan(id).then((res) => {
                this.reservationPlan = res;
                this.title = res.title;
                this.duration = res.duration;
                this.availability = res.availability;
                this.plan = {
                    isAvailableNow: res.isAvailableNow,
                    customProgramDates: res.customProgramDates,
                    isMaxBookingDay: res.booking.isMaxBookingDay,
                    maxBookingDay: res.booking.maxBookingDay,
                    isMinBookingHour: res.booking.isMinBookingHour,
                    minBookingHour: res.booking.minBookingHour,
                };
                this.setting = {
                    isBufferTimeMinute: res.setting.isBufferTimeMinute,
                    bufferTimeMinute: res.setting.bufferTimeMinute,
                    isMaxBookingCountPerDay: res.setting.isMaxBookingCountPerDay,
                    maxBookingCountPerDay: res.setting.maxBookingCountPerDay,
                };
                this.calendarData = {
                    availabilityCalendarIds: res.availabilityCalendarIds,
                    calendarId: res.calendarId,
                };
                this.description = res.description;
                this.formInputs = res.formInputs;
            });
            this.isDataMounted = true;
            this.getBusyCalendarEvents();
            this.loading = false;
        } else {
            this.isDataMounted = true;
            this.loading = false;
        }
    },
    beforeRouteLeave(to, from, next) {
        if (!this.isCompleted) {
            this.$dialog
                .confirm(this.$t("calendar.sureContinueSaving"), {
                    okText: this.$t("message.continue"),
                    cancelText: this.$t("message.cancel"),
                })
                .then(() => {
                    next();
                });
        } else next();
    },
    watch: {
        "calendarData.availabilityCalendarIds": {
            handler(val) {
                if (val.length > 0) {
                    this.getBusyCalendarEvents();
                } else {
                    this.busyTimes = [];
                    this.calenderUpdated();
                }
            },
            deep: true,
        },
        availability: {
            handler(val) {
                this.calenderUpdated();
            },
            deep: true,
        },
        setting: {
            handler(val) {
                this.calenderUpdated();
            },
            deep: true,
        },
        duration(val) {
            this.calenderUpdated();
        },
        end(val) {
            this.calenderUpdated();
        },
    },
};
</script>

<style lang="scss">
#reservation > div.right > div > div.fc-view-harness.fc-view-harness-active > div > table > tbody > tr:nth-child(1) {
    display: none;
}

#reservation {
    .fc-day-today {
        background-color: white !important;
    }

    .ant-spin-container {
        width: 100%;
        display: flex;
    }
}
</style>

<style lang="scss" scoped>
#reservation {
    display: flex;
    width: 100%;
    height: 100%;
    background-color: white;

    .left {
        max-height: calc(100vh - 60px);
        overflow-y: auto;
        width: 30%;
        padding: 20px;
        box-shadow: 0px 0px 13px 3px rgb(72 72 72 / 20%);
        margin: 10px;
        border-radius: 20px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;

        .get-link {
        }

        .title {
            display: flex;
            justify-content: center;
            font-weight: 700;
            font-size: 15px;
        }

        .go-link {
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            margin-left: 35px;
            padding: 5px;

            .icon {
                font-size: 15px;
                margin-right: 5px;
            }
        }

        .description-input {
            width: 100%;
            border: none;
            border-bottom: 0.5px solid grey;
            margin: 20px 0;
            font-size: 15px;
        }

        .input-area {
            width: 100%;
            display: flex;
            justify-content: center;
            margin: 20px 0;

            .label-input {
                border: none;
                border-bottom: 0.5px solid grey;
                width: 85%;
                font-size: 16px;
            }
        }

        .footer {
            margin-top: 30px;
            width: 100%;
            display: flex;
            justify-content: space-between;
            align-items: center;

            .btn {
                cursor: pointer;
                margin: 5px 15px;

                &.back {
                    background-color: #f0f0f0;
                    color: black;
                }

                &.preview {
                    display: flex;
                    align-items: center;
                }

                .preview-icon {
                    font-size: 20px;
                    margin-right: 5px;
                }
            }
        }
    }

    .right {
        width: 70%;
        padding: 20px;
    }
}
</style>
